import { useIntl } from 'react-intl';

export const getMedicationUnit = (unit?: string | null, messages?: Record<string, string>) => {
  const formatID = `medication.opts.unit.${unit ?? ''}`;
  return messages?.[formatID] ? `${messages[formatID]}` : (unit ?? '');
};

const MedicationUnit = ({ unit }: IMedicationUnit) => {
  if (!unit) return <span></span>;
  const { messages } = useIntl();

  const formatID = `medication.opts.unit.${unit}`;
  const localizedString = messages[formatID] ? `${messages[formatID]}` : unit;
  return <span>{localizedString}</span>;
};

interface IMedicationUnit {
  unit: string | null | undefined;
}

export default MedicationUnit;
